import React, { FC } from "react";

import { CenteredItems, NoResourcesBlock } from "../Cards/styled";
import { CardsBlank, NoResourceDescription } from "./styled";

interface NoResourceProps {
  headerText: string;
  children?: React.ReactNode;
}

export const NoResource: FC<NoResourceProps> = ({ headerText, children }) => (
  <NoResourcesBlock>
    <CenteredItems>
      <CardsBlank />
      <NoResourceDescription>{headerText}</NoResourceDescription>
      <div>{children}</div>
    </CenteredItems>
  </NoResourcesBlock>
);
